module.exports = __webpack_public_path__ + "img/share-info.0411c8e9.png";